var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"token"},[_c('span',{class:( _obj = {}, _obj[_vm.type] = true, _obj )},[_vm._v(_vm._s(_vm.value))]),(_vm.type === 'key')?_c('span',{staticClass:"separator"},[_vm._v("=")]):_vm._e(),(_vm.type === 'value')?_c('span',{staticClass:"separator continuation"},[_vm._v("&")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }